import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { Field, sel } from "@/lib/finance";

const DEF = { active: true, method: "kademeli", rate: 0, calc_day: 5, min_margin: 0, deduct_returns: true, include_uncollected: true, include_deferred: true,
  tier_set_id: null, monthly_target: 0, show_cost: false, show_profit: false, show_margin: true, show_prim: true };
const CHECKS = [["active", "Prim Aktif"], ["deduct_returns", "İadeleri Düş"], ["include_uncollected", "Tahsil Edilmemiş Satışı Dahil Et"], ["include_deferred", "Vadeli Satışı Dahil Et"]];
const VIS = [["show_cost", "Maliyeti Göster"], ["show_profit", "Kâr TL Göster"], ["show_margin", "Kâr Marjını Göster"], ["show_prim", "Primi Göster"]];

export default function ProfileDialog({ row, sets, onClose, onDone }) {
  const [f, setF] = useState({ ...DEF, tier_set_id: sets.find((s) => s.is_default)?.id || null, ...(row.profile || {}) });
  const [busy, setBusy] = useState(false);
  const set = (k, num) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : num ? Number(e.target.value) : e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = Object.fromEntries(Object.keys(DEF).map((k) => [k, f[k]]));
    try { await api.put(`/prim/profiles/${row.user_id}`, body); toast.success("Prim ayarları kaydedildi (denetim kaydına yazıldı)"); onDone(); }
    catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };
  const box = ([k, l]) => <label key={k} className="flex items-center gap-2 text-[13px]"><input type="checkbox" checked={!!f[k]} onChange={set(k)} data-testid={`prim-profile-${k}`} />{l}</label>;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl" data-testid="prim-profile-dialog">
        <DialogHeader><DialogTitle>Prim Ayarları · {row.name}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid grid-cols-2 gap-3">
          <Field label="Hesaplama Tipi" className="col-span-2">
            <select className={`${sel} w-full`} value={f.method} onChange={set("method")} data-testid="prim-profile-method">
              <option value="kademeli">Kademeli Kâr Marjı Primi</option><option value="sabit">Sabit Ciro Primi</option>
            </select>
          </Field>
          {f.method === "sabit" ? (
            <Field label="Prim Oranı (%)"><Input type="number" step="0.01" min="0" max="100" value={f.rate} onChange={set("rate", true)} data-testid="prim-profile-rate" /></Field>
          ) : (
            <Field label="Kademe Tablosu"><select className={`${sel} w-full`} value={f.tier_set_id || ""} onChange={set("tier_set_id")} data-testid="prim-profile-tierset">
              {sets.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}</select></Field>
          )}
          <Field label="Prim Hesaplama Günü (1–28)"><Input type="number" min="1" max="28" value={f.calc_day} onChange={set("calc_day", true)} data-testid="prim-profile-day" /></Field>
          <Field label="Minimum Kâr Marjı (%)"><Input type="number" step="0.1" min="0" value={f.min_margin} onChange={set("min_margin", true)} data-testid="prim-profile-minmargin" /></Field>
          <Field label="Aylık Hedef (TL)"><Input type="number" min="0" value={f.monthly_target} onChange={set("monthly_target", true)} data-testid="prim-profile-target" /></Field>
          <div className="col-span-2 grid grid-cols-2 gap-2">{CHECKS.map(box)}</div>
          <div className="col-span-2 text-[12px] font-semibold text-slate-600 pt-1 border-t">Personel öz-görünümü (mobil)</div>
          <div className="col-span-2 grid grid-cols-2 gap-2">{VIS.map(box)}</div>
          <DialogFooter className="col-span-2"><Button type="submit" disabled={busy} data-testid="prim-profile-save">Kaydet</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
